import React from 'react';
import {
  Button,
} from 'reactstrap';
import PropTypes from 'prop-types';

const FileOpenInFigma = ({
  file,
  fileVersion,
}) => {
  const url = fileVersion ? fileVersion.attributes?.figma_url : file.attributes?.figma_url;

  if (!url) return null;

  if (file.deleted_at) return null;

  return (
    <Button
      size="sm"
      href={url}
      target="_blank"
      className="open-in-figma"
    >
      <img src="/images/integrations/figma.png" alt="Figma" />
      <span>Open in Figma</span>
    </Button>
  );
};

FileOpenInFigma.propTypes = {
  file: PropTypes.object.isRequired,
  fileVersion: PropTypes.object,
};

FileOpenInFigma.defaultProps = {
  fileVersion: null,
};

export default FileOpenInFigma;
